import { accessRole } from "../../../helpers/access_role"
import ErrorAccess from '../../../components/Error/Content/Access'
import React from "react"
import Index from './Index/View'
import Create from './Create/View'
import UpdateMutasi from './UpdateMutasi/View'

const RouteView = (props) => {
    const { params } = props    
    const queryParams = new URLSearchParams(props.location.search);
    const _uuid = queryParams.get('uuid')
    const _create = queryParams.get('create')
    const _updatemutasi = queryParams.get('updatemutasi')
    
    if (_create != null) {
        return accessRole('create') ? <Create uuid={_uuid} /> : <ErrorAccess />
    } else if (_updatemutasi != null) {
        return accessRole('update') ? <UpdateMutasi uuid={_uuid} /> : <ErrorAccess />
    }

    return accessRole('read') ? <Index /> : <ErrorAccess />
}

export default RouteView
